/**
 * AppSync mutation for AI Scheduler Expression Creator.
 * When the schema adds a human-readable field (e.g. `description`), include it in the selection
 * and map it in SchedulerAiCronAppSyncService — the scheduler UI already supports result.description.
 */
export const MUTATION_GENERATE_CRON_EXPRESSION = `
mutation GenerateCronExpression($prompt: String!) {
	generateCronExpression(prompt: $prompt) {
		expression
	}
}
`;
